export const propagationItemVariants = {
  hidden: {
    opacity: 0,
    y: -100,
  }, 
  show: {
    opacity: 1,
    y: 0,
  }
}